// src/services/KpiThresholdService.js
// Stores and evaluates configurable KPI threshold warnings for the Dashboard.
// Each KPI can have an enabled flag and a numeric threshold (value >= threshold → breach).

import storage from './StorageAdapter';

const STORAGE_KEY = 'rms_kpi_thresholds';

export const KPI_KEYS = ['geo_highRisk', 'bwra_unmitigated', 'prpt_review'];

export const KPI_THRESHOLD_DEFAULTS = {
  geo_highRisk:     { enabled: true,  threshold: 5 },
  bwra_unmitigated: { enabled: true,  threshold: 3 },
  prpt_review:      { enabled: true,  threshold: 2 },
};

class KpiThresholdService {
  getThresholds() {
    const stored = storage.getJSON(STORAGE_KEY, {});
    const merged = {};
    KPI_KEYS.forEach(key => {
      const def = KPI_THRESHOLD_DEFAULTS[key];
      merged[key] = stored[key] !== undefined
        ? { ...def, ...stored[key] }
        : { ...def };
    });
    return merged;
  }

  saveThresholds(thresholds) {
    storage.setJSON(STORAGE_KEY, thresholds);
  }

  resetThresholds() {
    storage.setJSON(STORAGE_KEY, {});
  }

  isBreached(key, value) {
    const thresholds = this.getThresholds();
    const cfg = thresholds[key];
    if (!cfg || !cfg.enabled) return false;
    return Number(value) >= Number(cfg.threshold);
  }

  /**
   * Returns an array of breached KPI objects.
   * @param {{ geo_highRisk: number, bwra_unmitigated: number, prpt_review: number }} stats
   */
  getBreachedKpis(stats) {
    const thresholds = this.getThresholds();
    const results = [];
    KPI_KEYS.forEach(key => {
      const value = stats[key] ?? 0;
      const cfg = thresholds[key];
      if (cfg && cfg.enabled && Number(value) >= Number(cfg.threshold)) {
        results.push({ key, value, threshold: cfg.threshold });
      }
    });
    return results;
  }
}

const kpiThresholdService = new KpiThresholdService();
export default kpiThresholdService;
